<template>
   <el-dialog title="交集" :visible.sync="viewVisible" :close-on-click-modal="false" @close="close">
    <el-form :model="intersectionForm" :rules="rules" ref="ruleForm" :disabled="isReadOnly" :label-width="formLabelWidth">
      <el-form-item label="节点名称" prop="name">
        <el-input v-model="intersectionForm.name" autocomplete="off" :maxlength="20"></el-input>
        <span class="nameTips">{{getNameLength}}/20</span>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="viewVisible = false">取 消</el-button>
      <el-button type="primary" :disabled="isReadOnly" @click="intersectionSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import mnode from "@/api/intelligentMarket/a_node";
export default {
  name: 'intersectionDialog',
  data() { 
    return {
      formLabelWidth: '80px',
      rules: {
        name: [
          { required: true, message: '请输入节点名称', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ]
      },
      intersectionForm: {
        name: ''
      }
    }
  },
  computed: {
    viewVisible: {
      get: function () {
        return this.visible
      },
      set: function (newValue) {
        if (newValue) {
          this.$emit('update:visible', true)
        } else {
          this.$emit('update:visible', false)
        }
      }
    },
    getNameLength: function () {
      return this.intersectionForm.name.length
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    nodeId: Number,
    marketingId: Number,
    'isReadOnly': {
      type: Boolean,
      default: false
    }
  },
  components:{
  },
  created() {
    //双击打开的时候显示节点名称
    mnode.getNode({nodeId: this.nodeId}).then(res => {
      if (res.code === 1 && res.data.name) {
        this.intersectionForm.name = res.data.name
      }
    })
  },
  methods:{
     intersectionSubmit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let data = this.getDataify()
          mnode.updateDetail(data).then(res => {
            if (res.code === 1) {
              this.$message.success(res.message)
              this.viewVisible = false
              this.$emit('change-name', data)
            }
          })
        } else {
          return false
        }
      })
    },
    getDataify () {
      let formData = {}
      formData.nodeId = this.$props.nodeId
      formData.name = this.intersectionForm.name
      return formData
    },
    close () {
      this.viewVisible = false
    }
  },
 }
</script>

<style>
</style>